export default function(){
    (function($) {
        $(".informations__drop-header").click(function () {
            $(this).toggleClass("informations__drop-header--active");
            $(this).next(".informations__drop-content").slideToggle();
        })
    })(jQuery);
}